export default __webpack_public_path__ + "static/media/lock_grey.702a99cf.png";